import { render, staticRenderFns } from "./PopularListing.vue?vue&type=template&id=bc35b930&scoped=true"
import script from "./PopularListing.vue?vue&type=script&lang=js"
export * from "./PopularListing.vue?vue&type=script&lang=js"
import style0 from "./PopularListing.vue?vue&type=style&index=0&id=bc35b930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc35b930",
  null
  
)

export default component.exports